module.exports = __webpack_public_path__ + "static/media/delete.3344a499.svg";